module.exports = __webpack_public_path__ + "img/xxdz.001e9a4c.jpg";